import { TransportChannel, TransportProvider } from 'models/transport';

export const transportProviderName = (provider?: TransportProvider) => {
    if (!provider || !provider.channel) {
        return 'transport-providers:NONE';
    }
    if (provider.channel === TransportChannel.OPTER) {
        return 'Denthub';
    } else if (provider.channel === TransportChannel.DENTHUB_TRANSPORT) {
        return `transport-providers:DENTHUB_TRANSPORT_${provider.externalId}`;
    } else if (provider.channel === TransportChannel.NSHIFT) {
        return `transport-providers:${provider.channel}_${provider.externalId}`;
    }
    throw new Error('transportProviderName() invalid transport provider.');
};
